module.exports = __webpack_public_path__ + "static/img/pup-bottom.6435547.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer2/pup-bottom.png
// module id = 8T34
// module chunks = 1